import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Dashboard.svg'

export const IconDashboard = IconSVG as IconComponent
